export default __webpack_public_path__ + "static/media/para-2.ca9d6c2f.png";